exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td[data-v-11d0cb4b],.table th[data-v-11d0cb4b]{vertical-align:middle}", ""]);

// exports
